import { makeStyles } from '@mui/styles';

const useAnimations = makeStyles({
	pulse: {
		animation: '$pulse 2s infinite'
	},
	'@keyframes pulse': {
		'0%': {
			opacity: 1
		},
		'50%': {
			opacity: 0.4
		},
		'100%': {
			opacity: 1
		}
	}
});

export default useAnimations;
